import { DivCheckbox } from "@talladega/components";
import translate from "@common/helpers/translate";
import { useRouter } from "next/router";
import { ChangeEvent } from "react";
import { VehicleFuelType } from "@modules/vehicle/types/Vehicle";
import {
  FilterAction,
  FilterActions,
  FilterKeys,
  FuelTypeFilter,
} from "../types/vehicleFilter";

type Props = {
  fuelTypes: VehicleFuelType[];
  onUpdate(filterAction: FilterAction): void;
  fuelTypeFilter: FuelTypeFilter[];
};

interface Orderable {
  order: number;
}

const orderFunction = (a: Orderable, b: Orderable) => a.order - b.order;

const VehicleFuelTypeFilter = ({
  fuelTypes,
  onUpdate,
  fuelTypeFilter,
}: Props) => {
  const router = useRouter();
  const locale = router.locale || "";

  const selectedFuelTypes = fuelTypeFilter.map((f) => f.state);

  const handleCheckChange = (
    event: ChangeEvent<HTMLInputElement>,
    displayFuelType: VehicleFuelType
  ) => {
    if (event.target.checked) {
      onUpdate({
        type: FilterActions.AddFuelTypeFilter,
        payload: {
          id: displayFuelType.id.toString(),
          name: displayFuelType.name,
        },
      });
    } else {
      onUpdate({
        type: FilterActions.RemoveByIdAndType,
        payload: {
          type: FilterKeys.FuelType,
          id: displayFuelType.id.toString(),
        },
      });
    }
  };

  return (
    <ul className="body-3 grid grid-cols-2 gap-2">
      {fuelTypes &&
        fuelTypes.sort(orderFunction).map((ft) => (
          <li key={ft.id}>
            <DivCheckbox
              id={`fuelType${translate(ft.name, locale || "en")}Filter`}
              objectValue={ft}
              onChangeEvent={handleCheckChange}
              isChecked={
                selectedFuelTypes.map((x) => x.id).indexOf(ft.id.toString()) >
                -1
              }
            >
              {translate(ft.name, locale)}
            </DivCheckbox>
          </li>
        ))}
    </ul>
  );
};

export default VehicleFuelTypeFilter;
